// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileView_file__8gQh1 {
  display: flex;
}

.FileView_info__Z\\+1Qv {
  display: flex;
  flex-direction: column;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
  min-width: 1px;
  overflow: hidden;
  margin-left: 8px;
}
.FileView_info__Z\\+1Qv > :not(:last-child) {
  margin-bottom: 4px;
}

.FileView_title__-OSR6 {
  color: #272A36;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.FileView_meta__Enqs3 {
  color: #8E8E93;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.FileView_icon__cOvHP {
  position: relative;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  line-height: 0;
  background: #4778EE;
  border-radius: 4px;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.FileView_iconPointer__4KY9u {
  cursor: pointer;
}

.FileView_loading__huA5E {
  width: calc(100% - 8px);
  height: 2px;
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.54);
}
.FileView_loading__value__OTvY3 {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 2px;
  background: white;
  transition: 0.2s all;
}

.FileView_iconError__dwnbP {
  position: relative;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  line-height: 0;
  border-radius: 4px;
  border: 1px solid rgba(226, 56, 52, 0.2);
  background: #FADFDF;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/FileView/FileView.module.scss","webpack://./src/assets/scss/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,cAAA;EACA,gBAAA;EAEA,gBAAA;AAFF;AAIE;EACE,kBAAA;AAFJ;;AAMA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ECvBA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADqBF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EC/BA,mBAAA;EACA,gBAAA;EACA,uBAAA;AD8BF;;AAIA;EACE,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EAEA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;AAKE;EACE,eAAA;AAHJ;;AAOA;EACE,uBAAA;EACA,WAAA;EAEA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,qCAAA;AALF;AAOE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EAEA,oBAAA;AANJ;;AAUA;EACE,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EAEA,kBAAA;EACA,wCAAA;EACA,mBAAA;AATF","sourcesContent":["@import '@/assets/scss/mixins.scss';\n\n.file {\n  display: flex;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  user-select: none;\n  min-width: 1px;\n  overflow: hidden;\n\n  margin-left: 8px;\n\n  &>:not(:last-child) {\n    margin-bottom: 4px;\n  }\n}\n\n.title {\n  color: #272A36;\n  font-size: 14px;\n  font-weight: 400;\n\n  @include ellipsis;\n}\n\n.meta {\n  color: #8E8E93;\n  font-size: 12px;\n  font-weight: 400;\n\n  @include ellipsis;\n}\n\n.icon {\n  position: relative;\n\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  line-height: 0;\n\n  background: #4778EE;\n  border-radius: 4px;\n  border: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &Pointer {\n    cursor: pointer;\n  }\n}\n\n.loading {\n  width: calc(100% - 8px);\n  height: 2px;\n\n  position: absolute;\n  bottom: 4px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.54);\n\n  &__value {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    border-radius: 2px;\n    background: white;\n\n    transition: 0.2s all;\n  }\n}\n\n.iconError {\n  position: relative;\n\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  line-height: 0;\n\n  border-radius: 4px;\n  border: 1px solid rgba(226, 56, 52, 0.20);\n  background: #FADFDF;\n}\n","@mixin ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin invisible-scroll {\n  overflow: -moz-scrollbars-none;\n  overflow: -moz-hidden-unscrollable;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n    -ms-overflow-style: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"file": `FileView_file__8gQh1`,
	"info": `FileView_info__Z+1Qv`,
	"title": `FileView_title__-OSR6`,
	"meta": `FileView_meta__Enqs3`,
	"icon": `FileView_icon__cOvHP`,
	"iconPointer": `FileView_iconPointer__4KY9u`,
	"loading": `FileView_loading__huA5E`,
	"loading__value": `FileView_loading__value__OTvY3`,
	"iconError": `FileView_iconError__dwnbP`
};
export default ___CSS_LOADER_EXPORT___;
